// import { task } from '../schemas';

// const _ = require('lodash');

// ------------------------------------
// Constants
// ------------------------------------
export const ADD_FEEDBACK = 'ADD_FEEDBACK';
export const CLEAR_FEEDBACK = 'CLEAR_FEEDBACK';

// ------------------------------------
// Actions
// ------------------------------------

export function addFeedback(level, message) {
  // console.log('adding feedback', level, message);
  return {
    type: ADD_FEEDBACK,
    payload: {
      level,
      message,
    },
  };
}

export function clearFeedback() {
  return {
    type: CLEAR_FEEDBACK,
  };
}

export const actions = {
  addFeedback,
  clearFeedback,
};

const TASK_ACTION_HANDLERS = {
  [ADD_FEEDBACK]: (state, action) => [
    ...state,
    {
      ...action.payload,
    },
  ],
  [CLEAR_FEEDBACK]: (state, action) => [],
};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = [];

export default function taskReducer(state = initialState, action) {
  const handler = TASK_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/feedback.js